import styled from "styled-components";

export const Container = styled.div`
  width: min(960px, calc(100% - 24px));
  margin: 24px auto;
  padding: 24px;
  border: 1px solid #d5d8de;
  border-radius: 20px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  box-shadow: 0 18px 32px rgba(20, 36, 61, 0.12);
  font-family: "Segoe UI", "Helvetica Neue", Arial, sans-serif;

  @media (max-width: 760px) {
    padding: 18px;
  }
`;

export const Header = styled.h1`
  margin: 0;
  color: #111827;
  text-align: center;
  font-size: clamp(24px, 2.8vw, 40px);
`;

export const Formula = styled.p`
  margin: 8px 0 24px;
  color: #4b5563;
  text-align: center;
  font-size: clamp(14px, 1.3vw, 18px);
  line-height: 1.5;
`;

export const InputsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  padding: 12px;
  border: 1px solid #d1d5db;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.8);
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  color: #374151;
  font-size: 14px;
  font-weight: 700;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  color: #0f172a;
  background: #ffffff;
  font-size: 17px;
  transition: border-color 180ms ease, box-shadow 180ms ease;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  }
`;

export const ResultsGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  margin-top: 20px;
`;

export const ResultCard = styled.div`
  padding: 18px;
  border: 1px solid #bfdbfe;
  border-radius: 16px;
  background: linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%);
  text-align: center;
`;

export const ResultLabel = styled.p`
  margin: 0 0 8px;
  color: #1e40af;
  font-size: 14px;
  font-weight: 700;
`;

export const ResultValue = styled.p`
  margin: 0;
  color: #0f172a;
  font-size: clamp(28px, 3.4vw, 42px);
  font-weight: 800;
  line-height: 1.2;
`;

export const Notice = styled.p`
  margin: 14px 0 0;
  padding: 12px 14px;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  color: #334155;
  background: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  line-height: 1.5;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

export const ResetButton = styled.button`
  border: none;
  border-radius: 12px;
  padding: 11px 20px;
  color: #ffffff;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    box-shadow: 0 10px 20px rgba(29, 78, 216, 0.28);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
